import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, Sun, Wind, Droplets } from 'lucide-react';
export function Weather() {
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-435">
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-436">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-437">
          Campus Weather
        </motion.h1>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-438">
        <div className="bg-gradient-to-br from-blue-500 to-blue-700 rounded-3xl shadow-2xl overflow-hidden text-white p-8 md:p-12" data-id="element-439">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-440">
            <div className="text-center md:text-left" data-id="element-441">
              <h2 className="text-3xl font-bold mb-2" data-id="element-442">IIT Madras, Chennai</h2>
              <p className="text-blue-100 text-lg mb-8" data-id="element-443">Current Conditions</p>

              <div className="flex items-center justify-center md:justify-start gap-6" data-id="element-444">
                <Sun size={80} className="text-yellow-300" data-id="element-445" />
                <div className="text-7xl font-bold" data-id="element-446">
                  32°<span className="text-4xl text-blue-200" data-id="element-447">C</span>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 w-full md:w-64 space-y-6" data-id="element-448">
              <div className="flex items-center justify-between" data-id="element-449">
                <div className="flex items-center gap-2" data-id="element-450">
                  <Wind size={20} data-id="element-451" /> Wind
                </div>
                <span className="font-bold" data-id="element-452">12 km/h</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-453">
                <div className="flex items-center gap-2" data-id="element-454">
                  <Droplets size={20} data-id="element-455" /> Humidity
                </div>
                <span className="font-bold" data-id="element-456">65%</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-457">
                <div className="flex items-center gap-2" data-id="element-458">
                  <Cloud size={20} data-id="element-459" /> Cloud Cover
                </div>
                <span className="font-bold" data-id="element-460">20%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}